<template>
<div class="smart-form">
  <div class="smart-icon">
      <img src="../assets/bahn.png" width="120px"/>
     </div>
    <div class="screentime-hl">Weshalb verspätet sich die Deutsche Bahn im Fernverkehr am häufigsten?</div>
    
  <div class="screentime-form">
      <form v-if="hasQuizForm"> 
        <br>
           <div class="inner-form">
         <button class="gen_button" v-on:click.prevent="generateOption1">Störung im Betriebsablauf</button>
          &nbsp;&nbsp;
         <button class="gen_button" v-on:click.prevent="generateOption2">Störung am Zug</button>
          &nbsp;&nbsp;
         <button class="gen_button" v-on:click.prevent="generateOption3">Störung der Strecke</button>
<br>
 <br>
</div></form>
  </div>
  <div v-if="hasChoosen" class="smartphone-dataviz">
  <br>
         <div class="screentime-description" v-html="quizDescription"> <br><br>
        </div>
    <br><br>
   <div class="dataviz-source"> Quelle: Zugfinder</div>
  </div>
  </div>
</template>


<script>
export default {
  name: 'Quiz',
  props: {
    
  },
  data() {
        return {
            optionChoosen: "",
            hasChoosen: false,
            hasQuizForm:true       }     
    },
    computed: {
       
         quizDescription: function () {
        let smartAppMsg="";
        
            if (this.optionChoosen == "Option1") {
                smartAppMsg= "Nur in <b>16% der Fälle </b>verschulden Störungen am Zug eine Verspätung. Störungen an der Strecke sind für <b>15%</b> verantwortlich. Sie liegen also richtig: <br><br><b>50% </b> der Verspätungen entstehen auf Grund von Störungen im Betriebsablauf, dazu zählen Verspätungen vorausfahrender Züge, Warten auf Anschlussreisende, Verspätung aus vorheriger Fahrt, verspätetes Personal aus vorheriger Fahrt oder verspätete Bereitstellung. <br><br> (Die Werte ergeben sich aus 245.000 Verbindungen im Fernverkehr mit mindestens sechs Minuten Verspätung oder mindestens einem ausgefallenen Halt vom Dezember 2019 bis Mai 2022.)"
            }
            if (this.optionChoosen == "Option2") {
                smartAppMsg= "Mit der Störung am Zug liegen sie leider falsch. Die Züge im Fernverkehr sind doch robust als gedacht und verschulden nur <b> in 16% der Fälle </b> eine Verspätung. <br><br> <b>50%</b>der Verspätungen entstehen auf Grund von Störungen im Betriebsablauf, dazu zählen Verspätungen vorausfahrender Züge, Warten auf Anschlussreisende, Verspätung aus vorheriger Fahrt, verspätetes Personal aus vorheriger Fahrt oder verspätete Bereitstellung.<br><br>(Die Werte ergeben sich aus 245.000 Verbindungen im Fernverkehr mit mindestens sechs Minuten Verspätung oder mindestens einem ausgefallenen Halt vom Dezember 2019 bis Mai 2022.)"
            }
            if (this.optionChoosen == "Option3") {
                smartAppMsg= "Mit der Störung der Strecke liegen Sie leider falsch. Es gibt wohl zu wenig Schienen, aber eine Störung ist nur in <b>15% der Fälle </b>für eine Verspätung verantwortlich. <br><br><b>50% </b>der Verspätungen entstehen auf Grund von Störungen im Betriebsablauf, dazu zählen Verspätungen vorausfahrender Züge, Warten auf Anschlussreisende, Verspätung aus vorheriger Fahrt, verspätetes Personal aus vorheriger Fahrt oder verspätete Bereitstellung.<br><br>(Die Werte ergeben sich aus 245.000 Verbindungen im Fernverkehr mit mindestens sechs Minuten Verspätung oder mindestens einem ausgefallenen Halt vom Dezember 2019 bis Mai 2022.)"
            }
                        
            return (smartAppMsg)
            }
            
       

    },
  methods: {
        generateOption1: function () {
            if (this.hasChoosen==true){
                this.hasChoosen = false;
                this.optionChoosen = "";
            } else {
            this.hasChoosen=true;
             this.hasQuizForm = false;
             this.optionChoosen = "Option1";
           
           }  
        },
         generateOption2: function () {
            if (this.hasChoosen==true){
                this.hasChoosen = false;
                this.optionChoosen = "";
            } else {
            this.hasChoosen=true;
             this.hasQuizForm = false;
             this.optionChoosen = "Option2";
           
           }  
        },
         generateOption3: function () {
            if (this.hasChoosen==true){
                this.hasChoosen = false;
                this.optionChoosen = "";
            } else {
            this.hasChoosen=true;
             this.hasQuizForm = false;
             this.optionChoosen = "Option3";
           
           }  
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import '../assets/styles.css';
</style>
